import React from 'react'
// view components
import ReviewBar from 'components/Modals/PlanItems/components/ReviewBar'
// constants
import { Modals } from 'constants/index'
// views
import { Button, ButtonLabel } from 'components/Modals/PlanItems/components/CompleteReview/views'
// hooks
import { useCurrentUser, useShowModal } from 'hooks/index'
// utils
import { getReviewToApprove, isUserReviewer } from 'utils/reviews'

// types
interface IIncomingProps {
  entity: any
  isFullModal?: boolean
  isSidebar?: boolean
  hideModal?: () => void
}

// Shown only to the review's approver (user or position) until the review is approved
const ApproveReview: React.FunctionComponent<IIncomingProps> = ({ entity, isFullModal, isSidebar, hideModal }) => {
  const currentUser = useCurrentUser()

  const { showModal: showReviewCreateModal } = useShowModal({ modalType: Modals.REVIEW_CREATE_MODAL })

  const review = getReviewToApprove(entity, currentUser)

  if (!review) {
    return null
  }

  // the review is already complete, so the drawer must update it on submit instead of creating a new one;
  // an approver who isn't also a reviewer gets it read-only (isApprove)
  const handleOpenReview = () => {
    showReviewCreateModal({ entity, review, isUpdate: true, isApprove: !isUserReviewer(review, currentUser) })

    if (isFullModal) {
      hideModal?.()
    }
  }

  return (
    <ReviewBar hideDueIndicator review={review} isFullModal={isFullModal} isSidebar={isSidebar}>
      <Button data-testid='approve-review' $isFullModal={isFullModal || isSidebar} onClick={handleOpenReview}>
        <ButtonLabel>APPROVE REVIEW</ButtonLabel>
      </Button>
    </ReviewBar>
  )
}

export default ApproveReview
